type TSplitTests = {
  tests: {
    name: 'partner_loan_purpose_split_test_2025'; // add split test names here as strings
    branches: {
      branchName: string;
      testPercentage: number;
    }[];
    defaultBranch: string;
    customerIsActive: boolean;
    testIsActive: boolean;
  }[];
};

export const SPLIT_TESTS: TSplitTests = {
  tests: [
    {
      name: 'partner_loan_purpose_split_test_2025',
      branches: [
        {
          branchName: 'INCLUDE',
          testPercentage: 0.5,
        },
      ],
      defaultBranch: 'EXCLUDE',
      customerIsActive: true,
      testIsActive: true,
    },
    // Left as an example
    // {
    //   name: 'company_number_prefill_test_2024',
    //   branches: [
    //     {
    //       branchName: 'INCLUDE',
    //       testPercentage: 0.5,
    //     },
    //   ],
    //   defaultBranch: 'EXCLUDE',
    //   customerIsActive: window.location.pathname.includes('monzo'),
    //   testIsActive: true,
    // },
  ],
};
